import styled, { css, keyframes } from 'styled-components';

const MOBILE_MAX = '882px';
const DESKTOP_MIN = '883px';

// Transição estado 1 → 2: fade + slide vertical (~8px), 250ms.
const fadeSlide = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Pulso do número + ícone do relógio (escala 1 → 1.10 → 1).
const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: #ffffff;
  background-color: #000000;
  transition: background-color 250ms ease;
  overflow: hidden;

  @media (min-width: ${DESKTOP_MIN}) {
    height: 52px;
    padding: 0 24px;
  }

  @media (max-width: ${MOBILE_MAX}) {
    min-height: 48px;
    padding: 8px 16px;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 1402px;
  text-align: center;
  animation: ${fadeSlide} 250ms ease;
`;

export const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-left: 4px;
  margin-right: 4px;
`;

export const Message = styled.div`
  font-weight: ${({ emphasis }) => (emphasis ? 700 : 500)};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CountdownValue = styled.strong`
  display: flex;
  align-items: center;
  justify-content: center;
  font-variant-numeric: tabular-nums;
  font-weight: 800;
  font-family: Nunito, sans-serif;
  font-size: 20px;

  ${({ pulsing }) =>
    pulsing &&
    css`
      animation: ${pulse} 220ms ease-out;
    `}
`;

// Alternância de texto desktop/mobile via CSS (padrão dos banners do app).
export const DesktopText = styled.span`
  @media (max-width: ${MOBILE_MAX}) {
    display: none;
  }
  font-family: 'Roboto', sans-serif;
  font-size: 18px;
`;

export const MobileText = styled.span`
  @media (min-width: ${DESKTOP_MIN}) {
    display: none;
  }
  font-family: Nunito, sans-serif;
  font-size: 16px;
`;
